





































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import VendorMixin from '@/mixins/VendorMixin.vue';
import {nil} from '@/common';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import ImageGrid from '@/components/Views/UI/ImageGrid.vue';
import ImageGrid2 from '@/components/Views/UI/ImageGrid2.vue';

@Component({
    components: {ImageGrid2, ImageGrid},
})
export default class VendorProfileDialog extends Mixins(VendorMixin, UserRoleMixin) {
    @Prop({default: 'Book Now'})
    public callToAction!: string;

    @Prop({default: true})
    public callToActionBig!: boolean;

    public claim: any = null;
    public vendor: any = null;
    public images: string[] = [];
    public reviews: any[] = [];
    public open = false;
    public tab = 0;

    public openWith(vendor, claim) {
        this.vendor = vendor;
        this.claim = claim;
        this.open = true;
    }

    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (!value) {
            this.vendor = null;
            this.claim = null;
        } else {
            this.getImages();
        }
    }

    public async getImages() {
        this.images = await this.vendorWorkImages(this.vendor);
        this.reviews = await this.vendorReviews(this.vendor);
    }


    public closeDialog() {
        this.open = false;
    }

    public get noRegion() {
        return this.noVendor || nil(this.vendor.region);
    }

    public get noVendor() {
        return nil(this.vendor);
    }

    public get noAddress() {
        return this.noVendor || nil(this.vendor.address);
    }

    public get noTier() {
        return this.noVendor || nil(this.vendor.tierModel);
    }
    public get vendorIsMe() {
        if (this.userIsNull || this.noVendor || nil(this.user.vendorModel) || this.user.vendorModel._id !== this.vendor._id) { return false; }
        return this.user.vendorModel._id === this.vendor._id;
    }
    public get vendorName() {
        return this.noVendor ? '' : (this.userIsAdmin || this.vendorIsMe) ? `${this.vendor.firstName} ${this.vendor.lastName}` : this.vendor.firstName;
    }

    public get hasReviews() {
        return this.noVendor ? false : this.vendor.reviews.length !== 0;
    }

    public get hasClaim() {
        return !nil(this.claim);
    }
    public get asSelectionMap() {
        const obj = {};
        if (nil(this.vendor) || nil(this.vendor.workImages, true)) { return obj; }
        for (const image of this.vendor.workImages) {
            obj[image] = true;
        }
        return obj;
    }
    public get hasCallToAction() {
        return !nil(this.callToAction, true);
    }


}
